import "./Navbar.css";
import { Link } from "react-router-dom";
import { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">

  <div className="logo">
  <h1>
    <span className="cfhh0d">Interior</span>Mart
  </h1>
</div>

  {/* Mobile Icon */}

  <div
    className="menu-icon"
    onClick={() => setMenuOpen(!menuOpen)}
  >
    {menuOpen ? <FaTimes /> : <FaBars />}
  </div>

  <ul className={menuOpen ? "nav-links active" : "nav-links"}>

  <li>
    <Link to="/" onClick={() => setMenuOpen(false)}>
      Home
    </Link>
  </li>

  <li>
    <Link
      to="/our-products"
      onClick={() => setMenuOpen(false)}
    >
      Our Products
    </Link>
  </li>

  <li>
    <Link
      to="/brands"
      onClick={() => setMenuOpen(false)}
    >
      Brands
    </Link>
  </li>

  <li>
    <Link
      to="/find-professional"
      onClick={() => setMenuOpen(false)}
    >
      Find Professional
    </Link>
  </li>

  <li>
    <Link
      to="/about"
      onClick={() => setMenuOpen(false)}
    >
      About Us
    </Link>
  </li>

  <li>
    <Link
      to="/register-professional"
      onClick={() => setMenuOpen(false)}
    >
      Register as a Professional
    </Link>
  </li>

  <li>
    <Link
      to="/contact"
      onClick={() => setMenuOpen(false)}
    >
      Contact Us
    </Link>
  </li>

  <a
    href="https://wa.me/919876543210"
    target="_blank"
    rel="noopener noreferrer"
    onClick={() => setMenuOpen(false)}
  >
    <button>WhatsApp</button>
  </a>

</ul>

</nav>
  );
}

export default Navbar;